<template>
  <div class="container">
    <CommonHeader
      :title="title"
      :value="value"
    />
    <LongList
      :api-method="getData"
    >
      <template #default="{list}">
        <BillTable
          :data="list"
          :columns="columns"
          @show-tip="onClickShowTip"
        />
      </template>
    </LongList>
    <TipModal
      v-model="showTip"
      :title="tip.title"
      :msg="tip.msg"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { formatAmount, formatRatio, getLabel } from '@/util/filter';
import { COUPON_TYPE, COUPON_TYPE_OPTIONS } from '@/constants/bill';
import Api from '@/api/bill';
import BillTable from '@/components/BillTable';

export default {
  name: 'CouponDetail',
  components: { BillTable },
  data() {
    const { amount } = this.$route.query;
    let { couponType } = this.$route.query;
    couponType = parseInt(couponType, 10);
    const isFreeTime = [COUPON_TYPE.FREE_TIME, COUPON_TYPE.FREEDISCOUNT].includes(couponType);

    const columns = [
      {
        label: '门店名称',
        prop: 'poiName',
        fixed: 'left',
        minWidth: '150px',
      },
      {
        label: '核销数量(张)',
        prop: 'writeOffCount',
      },
      {
        label: '核销金额(元)',
        formatter(row) {
          return formatAmount(row.writeOffAmount);
        },
        tip: {
          title: '核销金额',
          msg: '【核销金额】为商家实际支付订单时使用优惠券抵扣的金额，如订单6元，使用券抵扣2元，实际支付4元，则【核销金额】为2元。',
        },
      },
    ];
    if (!isFreeTime) {
      columns.push({
        label: '平台服务费比例',
        formatter(row) {
          return formatRatio(row.serviceProp);
        },
      },
      {
        label: '账单金额(元)',
        formatter(row) {
          return formatAmount(row.billAmount);
        },
      });
    }

    return {
      couponType,
      isFreeTime,
      title: getLabel(couponType, COUPON_TYPE_OPTIONS),
      value: isFreeTime ? '' : `账单金额：${amount}元`,
      columns,
      showTip: false,
      tip: {},
    };
  },
  computed: {
    ...mapState('billModule', ['currentBilledInfo', 'customerId']),
  },
  methods: {
    getData(pageNum, pageSize) {
      const { couponType, customerId } = this;
      const { cutMonth: billMonth, settleUnitId } = this.currentBilledInfo;
      const params = {
        customerId,
        billMonth,
        couponType,
        settleUnitId,
        pageSize,
        pageNum,
      };
      return Api.getCouponDetail(params);
    },
    onClickShowTip(tip) {
      this.tip = tip;
      this.showTip = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 16px;
}
</style>
